export default __webpack_public_path__ + "static/scientist5-2469a89fffe7df4fa52c7a466ca4ab10.png";